/** @jsxImportSource @emotion/react */
import Amex from './icons/Amex';
import BankOfAmerica from './icons/BankOfAmerica';
import CapitalOne from './icons/CapitalOne';
import Chase from './icons/Chase';
import Citi from './icons/Citi';
import Discover from './icons/Discover';
import Mastercard from './icons/Mastercard';
import Usaa from './icons/Usaa';
import Visa from './icons/Visa';
import Wellsfargo from './icons/Wellsfargo';

interface Props {
  cardType: string;
}

/**
 * Returns an SVG icon of the given card type.
 *
 * TODO: update cardType keys to match what vista returns
 *
 * @param cardType string of the card type.
 */
const CardIcon = ({ cardType }: Props) => {
  const newType = cardType?.toLowerCase();
  return (
    {
      amex: <Amex />,
      'bank of america': <BankOfAmerica />,
      'capital one': <CapitalOne />,
      chase: <Chase />,
      citi: <Citi />,
      discover: <Discover />,
      mastercard: <Mastercard />,
      usaa: <Usaa />,
      visa: <Visa />,
      wellsfargo: <Wellsfargo />,
    }?.[newType] || null
  );
};

export default CardIcon;
